module.exports = __webpack_public_path__ + "static/media/majorG4.6942a12.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorG4.wav
// module id = cFix
// module chunks = 0